import React from 'react'
import './Style.css'
import Nature from '../Images/study.mp4'
import { Link, animateScroll as scroll } from "react-scroll";
import Navbar from './Navbar'

export default function Section1() {
    return (
        <>
            <video src={Nature} autoPlay muted loop className='BgVid'></video>
            <div className="overflow">
                <section className="section1">

                    {/* Navbar */}
                    <Navbar />

                    <div className="main-container w-screen">
                        <h1 className="main-title">Ganitgya Classes</h1>
                        <p className="sub-title">From career development to personal enrichment, our courses and resources provide the knowledge and skills you need to succeed in today's ever-changing world. Start your journey to lifelong learning today!</p>
                        <button className="button">
                            <Link to='contact' spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}><span className="button_lg">
                                    <span className="button_sl"></span>
                                    <span className="button_text">Join Now</span>
                                </span></Link>
                        </button>
                        {/* <a className="btn"><div className="button">
                    <div className="box">J</div>
                    <div className="box">O</div>
                    <div className="box">I</div>
                    <div className="box">N</div>
                </div></a> */}
                    </div>
                    {/* <img src={Sapiens} className='sapiens' alt="" srcset="" /> */}
                    <div className="waveWrapper waveAnimation">
                        <div className="waveWrapperInner bgTop">
                            <div className="wave waveTop"
                                style={{ backgroundImage: "url('http://front-end-noobs.com/jecko/img/wave-top.png')" }}></div>
                        </div>
                        <div className="waveWrapperInner bgMiddle">
                            <div className="wave waveMiddle"
                                style={{ backgroundImage: "url('http://front-end-noobs.com/jecko/img/wave-mid.png')" }}></div>
                        </div>
                        <div className="waveWrapperInner bgBottom">
                            <div className="wave waveBottom"
                                style={{ backgroundImage: "url('http://front-end-noobs.com/jecko/img/wave-bot.png')" }}></div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
